<template>
  <div class="view-container">
    <div class="history_status">
      <h2>Order History</h2>
      <hr />
      <div v-if="orders.length > 0">
        <div v-for="order in sortedOrders" :key="order.id" name="OrderContainer" :data-id="order.id">
            <div>{{order.referenceNumber}} || {{order.purchaseOrderStatus}}</div>
            <h5>{{order.createdDate}}</h5>
            <div class="product-image-container">
                    <img v-for="item in order.items" :key="item.id + '-' + item.items.map(m => m.name)" class="productImg" :src="item.imageURL" />
            </div>
            <button class="btn repeat btn-primary"><i class="fa fa-repeat"></i> Repeat</button>
        </div>
      </div>
      <h3 v-else>You have no orders in your history.</h3>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./History.vue.js";

export default {
  name: "History",
  components: {
  },
  mixins: [view],
  data() {
    return {
      orders: []
    }
  },
  created() {
    if(localStorage.userMembershipID == null){
      this.$router.push({ path: 'Login', query: { returnUrl: "History" }});
    }
  },
  mounted() {
    var _self = this;
    var data = {
        FranchiseID: localStorage.franchiseID,
        MembershipUserID: localStorage.userMembershipID,
        GUID: localStorage.cartGuid
    }
    _self.$ooApi.orders.history.v1(data).then(function (result) {
        _self.orders = result.data.sort(function(a, b) {
          return a.id - b.id;
        });
    }).then(function(){
      if(_self.orders.length > 0){
        document.querySelectorAll('div[name=OrderContainer]').forEach(item => {item.addEventListener("click", _self.showOrder);})
        document.querySelectorAll('div[name=OrderContainer] button.repeat').forEach(item => {item.addEventListener("click", _self.repeatOrder)});
      }
    });
  },
  computed: {
    sortedOrders: function(){
      return this.orders.slice().sort().reverse();
    }
  }
};
</script>
<style scoped>
    @import './History.vue.css'; 
</style>
